import axios, {
  baseUrl,
  baseUrlSpec,
  isProduction,
  isTest,
  apiProxyUrl,
} from './_config'
import timeOutAxios from './_timeOutConfig'
import urljoin from 'urljoin'
let maintainUrl = isProduction ? 'http://116.62.224.95' : baseUrl

export default axios

export {
  timeOutAxios,
  axios,
  baseUrl,
  baseUrlSpec,
  isProduction,
  isTest,
  maintainUrl,
  apiProxyUrl,
}

export const urlList = {
  tools: apiProxyUrl + `/tools/`,

  rent: apiProxyUrl + `/rent/`,
  rentLease: apiProxyUrl + `/`,
  // house房源接口地址
  house: apiProxyUrl + `/house/`,
  // contract合同接口地址
  contract: apiProxyUrl + `/contract/`,
  // account登录接口地址
  account: apiProxyUrl + `/account/`,
  // pdf接口地址
  pdf: apiProxyUrl + `/oss/`,
  // pay接口地址
  pay: apiProxyUrl + `/`,
  // pay接口地址
  jx: apiProxyUrl + `/pay`,
  // 工作流接口地址
  workflow: apiProxyUrl + `/workflow/`,
  // 售后服务接口地址
  service: apiProxyUrl + `/maintain/`,
  // 搜索引擎接口地址
  search: apiProxyUrl + `/search/`,
  // 维修物品接口地址
  category: apiProxyUrl + `/data/`,
  // 三级联动接口地址
  block: apiProxyUrl + `/block/`,
  // 同步房源数据到蘑菇租房
  alipay: apiProxyUrl + `/house/sync/`,
  // 智能门锁
  lock: apiProxyUrl + `/lock/`,

  userInfo: apiProxyUrl + `/account/user/info/`,
  // 电费
  ec: apiProxyUrl + `/ec`,
  // 空调项目配置 ssf
  air: apiProxyUrl + '/ec/air/condition/config/',
  central: apiProxyUrl + '/central',
  // 设备配置
  ele: apiProxyUrl + `/ele`,
  // 营销规则
  sale: apiProxyUrl + `/saleActivity`,
  // 保存修改的房源信息
  houseinfo: apiProxyUrl + `/contract/`,
  // 推送到房管局
  pushHomeInfo: apiProxyUrl + '/house_publish/fgj/',
  // 费用明细
  expenseDetails: apiProxyUrl + '/pay/zh/energy/get/child/order/',
}

export const api = {
  house: {
    list: params =>
      axios.post(
        urljoin(urlList.house, 'list/houseSpaceInHouseSpaceManager/v2'),
        params
      ),
    roomlist: params =>
      axios.post(urljoin(urlList.house, 'list/houseSpace'), params),
    retrieve: id =>
      axios.post(urljoin(urlList.house, 'get'), { houseSpaceId: id }),
  },
  contract: {
    list: params => axios.post(urljoin(urlList.contract, 'list'), params),
    listnew: params => axios.post(urljoin(urlList.contract, 'fgjlist'), params),
    retrieve: id =>
      axios.get(urljoin(urlList.contract, 'getContractDetailsById', id)),
    getContractDetailsAndMouthLastPlusById: id =>
      axios.get(
        urljoin(urlList.contract, 'getContractDetailsAndMouthLastPlusById', id)
      ),
    updataHouseInfo: params =>
      axios.post(
        urljoin(urlList.houseinfo, 'attachment/updateHouseInfo'),
        params
      ),
    pushHome: id =>
      axios.post(urljoin(urlList.pushHomeInfo, 'pushFw'), { contractId: id }),
    pushHomeNew: id =>
      axios.post(urljoin(urlList.pushHomeInfo, 'pushFwSpec'), {
        contractId: id,
      }),
  },
  lock: {
    retrieve: params =>
      axios.post(urljoin(urlList.lock, 'searchOnelock'), params),
  },
  password: {
    list: params => axios.post(urljoin(urlList.lock, 'list/pwd'), params),
    destroy: params => axios.post(urljoin(urlList.lock, 'del'), params),
    retrieve: params => axios.post(urljoin(urlList.lock, 'sendpwd'), params),
  },
  contractAttachment: {
    create: params =>
      axios.post(urljoin(urlList.contract, 'attachment/add'), params),
  },
  houseFile: {
    create: params => axios.post(urljoin(urlList.house, 'save/file'), params),
  },
  pay: {
    list: params => axios.post(urljoin(urlList.pay, 'pay/list'), params),
  },
  followUser: {
    destroy: id =>
      axios.post(urljoin(urlList.contract, 'deleteFollowUser', id), { id }),
  },
  userInfo: {
    retrieve: id => axios.get(urljoin(urlList.userInfo, 'cert', id)),
  },

  houseSpaceManager: {
    list(params) {
      return axios.post(urljoin(urlList.search, 'query/jurisdiction'), params)
    },
  },
}



// WEBPACK FOOTER //
// ./src/xhr/index.js